import React from 'react';
import { GroupLabel } from 'components/MenuList';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ComboBoxMenuGroupLabel(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(GroupLabel, {
    as: "li",
    children: children
  });
}